import React from "react";
import CnpjUtils from "../../../../shared/utils/CnpjUtils";
import MonetaryUtils from "../../../../shared/utils/MonetaryUtils";
import DateUtils from "../../../../shared/utils/DateUtils";
import IconAction from "../../../../shared/components/generic/button/icon-action/icon-action";

const clientStyle = {
	color: "#00518b",
	fontWeight: 700
};

const statusBaseStyle = {
	display: "inline-flex",
	alignItems: "center",
	gap: "4px",
	padding: "4px 16px",
	borderRadius: "16px",
	fontSize: "12px",
	whiteSpace: "nowrap"
};

const statusDotStyle = {
	width: "6px",
	height: "6px",
	borderRadius: "50%",
	backgroundColor: "currentColor"
};

const enabledActionStyle = {
	padding: 0,
	color: "#00518b",
	background: "transparent",
	border: 0,
	cursor: "pointer"
};

const disabledActionStyle = {
	...enabledActionStyle,
	color: "#c7cede",
	cursor: "not-allowed",
	opacity: 0.8
};

const getStatusConfig = status => {
	const normalizedStatus = String(status || "")
		.trim()
		.toUpperCase();

	const statusConfig = {
		ENVIADO: {
			label: "Enviado",
			style: {
				color: "#00518b",
				backgroundColor: "#49bff2"
			}
		},
		PENDENTE: {
			label: "Pendente de Envio",
			style: {
				color: "#59606c",
				backgroundColor: "#e8eaf0"
			}
		}
	};

	return statusConfig[normalizedStatus] || {
		label: status || "Indefinido",
		style: {
			color: "#4b5563",
			backgroundColor: "#eef0f3"
		}
	};
};

const getActionPermissions = status => {
	const normalizedStatus = String(status || "")
		.trim()
		.toUpperCase();

	return {
		canView: true,
		canEdit:
			normalizedStatus === "PENDENTE"
	};
};

export const columnsConfig = ({
	onView,
	onEdit
}) => [
	{
		key: "client",
		label: "Cliente",
		width: "25%",
		render: simulation => (
			<strong style={clientStyle}>
				{simulation.client || "-"}
			</strong>
		)
	},
	{
		key: "cnpj",
		label: "CNPJ",
		width: "18%",
		render: simulation => CnpjUtils.formatAlphanumericCnpj(simulation.cnpj) || "-",	
	},
	{
		key: "date",
		label: "Data",
		width: "15%",
		render: simulation => DateUtils.formatDateToBrazilian(simulation.date)
	},
	{
		key: "totalValue",
		label: "Valor Total",
		width: "16%",
		render: simulation => MonetaryUtils.formatCurrency(simulation.totalValue) || "-"
	},
	{
		key: "status",
		label: "Status",
		width: "14%",
		render: simulation => {
			const status = getStatusConfig(simulation.status);

			return (
				<span
					style={{
						...statusBaseStyle,
						...status.style
					}}
				>
					<span style={statusDotStyle} />
					{status.label}
				</span>
			);
		}
	},
	{
		key: "actions",
		label: "Ações",
		width: "12%",
		render: simulation => {
			const permissions = getActionPermissions(simulation.status);

			return (
				<IconAction
					row={simulation}
					actions={[
						{
							key: "view",
							variant: "view",
							title: "Visualizar simulação",
							ariaLabel: "Visualizar simulação",
							disabled: !permissions.canView,
							onClick: onView
						},
						{
							key: "edit",
							variant: "edit",
							title: permissions.canEdit
								? "Editar simulação"
								: "Esta simulação não pode ser editada",
							ariaLabel: "Editar simulação",
							disabled: !permissions.canEdit,
							onClick: onEdit
						}
					]}
				/>
			);
		}
	}
];